import script from "./BlockAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAccount.vue?vue&type=script&setup=true&lang=js"

import "./BlockAccount.vue?vue&type=style&index=0&id=9edd3a0c&lang=css"

const __exports__ = script;

export default __exports__